PaymentCtrl.$inject = [
    '$rootScope',
    '$scope',
    '$q',
    '$stateParams',
    '$state',
    '$location',
    'Analytics',
    'configs',
    'PortalApi',
    'Authentication',
    'ClientCards',
    'staticCategories',
    'Pay',
    'Localization',
    'AmountCommission',
    'DateFormater',
    'Counters',
    'Combobox',
    '$timeout',
    '$compile',
    '$interval'
];

function PaymentCtrl(
    $rootScope,
    $scope,
    $q,
    $stateParams,
    $state,
    $location,
    Analytics,
    configs,
    PortalApi,
    Authentication,
    ClientCards,
    staticCategories,
    Pay,
    Localization,
    AmountCommission,
    DateFormater,
    Counters,
    Combobox,
    $timeout,
    $compile,
    $interval
) {
    $scope.pay = Pay;
    $scope.AmountCommission = AmountCommission;
    $scope.cards = ClientCards.list;
    $scope.cardsMP = ClientCards.listMP;
    $scope.loggedUser = Authentication.isLogged;
    $scope.Auth = Authentication;
    $scope.language = Localization.active || 'uk';

    if ($scope.language == 'ua') {
        $scope.language = 'uk';
    }
    if(ClientCards.data.mpStatus == 'AUTHORIZED'){
        ClientCards.getList();
    }
    // for booking page
    Pay.data.bookingStart = '';
    Pay.data.booking = {
        currentSVGzoom: 1,
        events:{},
        furl:'',
        multiTypes: {
            getModalWindow: false
        },
        layout_id: null,
        moreInfoId: null,
        reserveMin: 0,
        reservedPlaces: [],
        reqData : {
            lang: $scope.language,
            id: null,
            eventId: null,
            legendId: null,
            removeTicket: []
        },
        seats:[],
        seatsId: '',
        sectorId: 0,
        sectorSelected: '',
        selectedEvent: {},
        serviceId: null,
        start: false,
        svgLink: {},
        temp: '',
        total: 0
    };

    $scope.growImgPopup = {
        show: false,
        ulr: ''
    };

    $scope.twoStepCreateForm = Pay.data.twoStepCreateForm;
    $scope.serviceId = Pay.data.serviceId;
    $scope.furl = Pay.data.furl;

    Pay.data.preLoader = true;
    Pay.data.load = "stepOne";   // hide content when we expect an answer

    $scope.isOpen = false;
    $scope.showBlock = false;   // hide or show blocks
    ClientCards.data.usedPrepaidCard = false;

    DateFormater.fields = Pay.data.fields;

    /*counters*/
    $scope.calculateMeters = function (meters, meterUnit) {
        Counters.calculateMeters(meters, meterUnit)
    };
    /*end counters*/

    /*clientCards*/
    $scope.ClientCards = ClientCards;
    $scope.Cards = ClientCards.list;
    $scope.number = ClientCards.data.number;

    var eChangeCardNumber = $rootScope.$on('changeCardNumber', function (e, type) {
        AmountCommission.localCalcCommission(type);
    });
    var eCountAmount = $rootScope.$on('countAmount', function () {
        AmountCommission.countAmount();
    });
    /*end clientCards*/

    $scope.keElectricity = $stateParams.serviceId == configs.payments_config.energyCalc.kievEnergoElectricity;

    if ($state.current.name == 'pages.service') {
        $rootScope.servicePage = true;
    }

    if ($state.current.name == 'pages.yasno' || $state.current.name == 'pages.yasnoP2P') {
        $rootScope.yasno = true;
    }

    //start remove chat-bot from yasno frame
    window.onload = function() {
        if ($rootScope.yasno) {
            angular.element('.widget-button').addClass("yasnoHiddenBot");
        }
    };
    //finish remove chat-bot from yasno frame

    Pay.amount = 0;
    Pay.amountInput = 0;
    Pay.amountWithCommission = 0;
    Pay.discount = 0;
    Pay.subsidy = 0;
    Pay.innerState = '';
    Pay.templateId = 0;
    Pay.user = Authentication.user;
    Pay.urlCode = $stateParams.urlCode;
    $interval.cancel($rootScope.timer);
    $q.all(
        [
            PortalApi.searchServices({
                // query: $stateParams.serviceId,
                service_id: $stateParams.serviceId,
                furl: $stateParams.url,
                limit: 1,
                location: 0,
                sortByPayments: false
            }),
            PortalApi.getService($stateParams.serviceId, $stateParams.url, $scope.language),
            ClientCards.getList()
        ]
    ).then(function (resolve) {

        Pay.commissions = [];
        Pay.payment = {};
        Pay.selectedGroup = {
            check: [],
            create: []
        };
        
        Pay.data.preLoader = true;
        Pay.data.searchServices = resolve[0][0] || {}; // search
        Pay.data.getService = resolve[1].plain(); // get

        if (Pay.data.getService.service) {

            Pay.data.serviceId = Pay.data.getService.service.id;
            Pay.data.furl = Pay.data.getService.service.furl;

            Pay.data.getService.service.amount_max = Pay.data.getService.service.amount_max / 100;
            Pay.data.getService.service.amount_min = Pay.data.getService.service.amount_min / 100;

            if(Pay.data.getService.service.redirect_from_id){
                $stateParams.serviceId = Pay.data.getService.service.id;
                $stateParams.url = Pay.data.getService.service.furl;
                $stateParams.destination = Pay.data.getService.service.destination;

                var obj = $location.search();

                if ($location.search().length > 0 || Object.keys($location.search()).length > 0) {
                    Pay.data.getService.fields.forEach(function (item) {
                        if (obj[item.alias]) {
                            item.value = decodeURIComponent(obj[item.alias]);
                        }
                    });
                    $stateParams.fields = Pay.data.getService.fields;
                }

                return $state.go('pages.payment', {
                    serviceId: $stateParams.serviceId,
                    url: $stateParams.url,
                    fields: $stateParams.fields,
                    autoCheck: false,
                    templateId: false,
                    destination: $stateParams.destination
                });
            }

        } else {
            $state.go('pages.error404');
        }

        /*category name*/
        staticCategories.cats.map(function (service) {
            //move category 32 into category other
            if (Pay.data.searchServices.category == 32) {
                Pay.data.categoryName = 'PAYMENTS.OTHER';
            } else if (Pay.data.searchServices.category == service.categoryId) {
                Pay.data.categoryName = service.name;
            }
            return service;
        });
        /*end category name*/
        /*booking page*/
        if(Pay.data.getService.fields){
            Pay.data.getService.fields.forEach(function (field) {
                if(field.type == 'DATE' || field.type == 'PERIOD'){
                    if(!field.value){
                        field.value = new Date;
                    }
                    if(!field.template){
                        field.template = 'dd.MM.yyyy';
                    }
                }
                // fix lang for MMMM YYYY EN, MMMM YYYY RU, MMMM YYYY UA tempaltes
                if (field.type == 'PERIOD') {
                    if (field.template == 'MMMM YYYY EN' || field.template == 'MMMM YYYY RU' || field.template == 'MMMM YYYY UA') {
                        let temp = angular.copy(field.template);
                        field.template = temp.slice(0, -3);                        
                    }
                }
            });
        }

        if (Pay.data.getService.service && Pay.data.getService.service.route == 'booking') {
            Pay.data.bookingStart = 'booking';
            Pay.data.booking.reqData = {
                lang: $scope.language,
                id: Pay.data.booking.serviceId = Pay.data.serviceId,
                eventId: null,
                legendId: null,
                removeTicket: []
            };

            var data = {
                serviceId: Pay.data.serviceId,
                fields: [],
                amount: 0,
                autoCheck: false,
                url: Pay.data.furl || Pay.data.serviceId
            };

            if ($state.current.name == 'pages.booking') {
                $scope.getStartBooking();
            }
            else {
                $state.go('pages.booking', data);
            }
        }
        /*finish booking page*/

        /*combobox service*/
        $scope.Combobox = Combobox;
        $scope.Combo = function (typed, vocabulary) {
            Combobox.get(typed, vocabulary);
        };
        /*end combobox service*/

        if (Pay.data.getService.service && Pay.data.getService.service.destination && !Pay.data.getService.service.destination_editable) {
            Pay.data.manualDestinition = Pay.data.getService.service.destination;
        }

        if (($stateParams.url != Pay.data.furl) &&
            ($stateParams.url != $scope.serviceId) &&
            ($stateParams.url != Pay.data.searchServices.id) &&
            (Pay.data.getService.service && Pay.data.getService.service.redirect_to_id)
        ) {
            var pageState = 'pages.error404';
            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.SERVICE_NOT_FOUND', 5, true);

            return $state.go(pageState);
        }

        Pay.info = Pay.data.searchServices; // element from init
        Pay.service = Pay.data.getService.service;
        DateFormater.fields = Pay.fields = Pay.data.getService.fields;
        Pay.defaultFields = angular.copy(Pay.data.getService.fields);
        Pay.commissions = Pay.data.getService.commissions;
        Pay.subsidyObj.haveSubsidy = Pay.data.getService.service.subsidy;
        Pay.subsidyObj.subsidy = 0;
        $scope.yasno();
        Pay.data.preLoader = false;

        if (Pay.data.serviceId == configs.payments_config.service.metallist) {
            Pay.data.bookingStart = 'metalist';
            $scope.getBookingEvents();
        }

        //new shitcode
        if(Authentication.frameLogin == 'ke-te'){
            DateFormater.fields.map(function(item) {
                if(item.name == 'PERIOD'){
                    setTimeout( function(){
                        var dateObj = new Date(item.value),
                            month = dateObj.getUTCMonth() + 1,
                            day = dateObj.getUTCDate(),
                            year = dateObj.getUTCFullYear();

                        item.value = new Date(year + "-" + (day +1));//transfer to 'correct' template for datepicker (exmp: 2016-12) set day as mounth
                    }, 1000)
                }
            });
        }

        Pay.init();

    }, function (res) { // if can't find our service show Notification and go to service page
        if (res) {
            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.SERVICE_NOT_FOUND', 5, true);

            $state.go('pages.error404');
        }
    });

    $scope.setSubsidy = function () {
        Pay.subsidyObj.subsidy = 0;
    };

    $scope.getCookie = function () {
        var aff_sub = "aff_sub=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(aff_sub) == 0) {
                Pay.options.salesDoubler = c.substring(aff_sub.length, c.length);
            }
        }
    };

    $scope.opening = function (open) {
        $scope.isOpen = !open;
    };

    $scope.yasno = function () {
        if ($rootScope.yasno) {
            // if (Pay.service.id == 6376) {    // dev id
            if (Pay.service.id == 13062) {   // prod id
                for (var i = 0; i < Pay.fields.length; i++) {
                    Pay.fields[i].heading += " lw";
                }
            }
            if (Pay.data.searchServices.category == 33) {
                for (var i = 0; i < Pay.fields.length; i++) {
                    Pay.fields[i].hint = '+380XXXXXXXXX'
                }
            }
        }

    };

    var eSelectProduct = $rootScope.$on('Counters.selectProduct', function (e, product) {
        Counters.selectProduct(product);
    });

    var ePayInit = $rootScope.$on('Pay.init', function () {

        /*refresh pay*/
        Pay.amount = 0;
        Pay.amountInput = 0;
        Pay.amountWithCommission = 0;
        Pay.selectedProduct = [];
        /*end pay*/

        ClientCards.data.userPaste = false;
        ClientCards.setNumberMask(true);

        ClientCards.list.forEach(function (obj) {
            if (obj.is_default) {
                $scope.haveDefault = true;
                $scope.defCard = obj;
            }

            if (Pay.info.category == 37 && obj.card_type == 'prepaid') {
                Pay.commissionHavePrepaid = true;
            }
        });

        if ($state.current.name == "pages.cardtocard") {
            ClientCards.data.showMPcards = false;
        } else {
            ClientCards.data.showMPcards = true;
        }

        if ($scope.haveDefault) {
            ClientCards.data.userPaste = true;
            ClientCards.setClientCard($scope.defCard);
        } else if (ClientCards.listMP.length > 0 && ClientCards.data.showMPcards && Pay.data.getService.service.masterpass_enabled) {
            ClientCards.setClientCard(ClientCards.listMP[0], 'masterpass');
            ClientCards.data.masterpass = true;
        } else if (ClientCards.list.length > 0) {
            ClientCards.setClientCard(ClientCards.list[0]);
        } else {
            ClientCards.data.id = 0;
        }

        for (var i = 0; i < $scope.cards.length; i++) {

            if ($scope.cards[i].id == $stateParams.from_card_id) {
                ClientCards.setClientCard($scope.cards[i]);
            }

            if ($scope.cards[i].id == $stateParams.to_card_id) {
                ClientCards.setTargetCard($scope.cards[i]);
            }
        }

        ClientCards.cancelCards();

        if($stateParams.amount && $stateParams.target) {
            ClientCards.data.target.card = $stateParams.target;
        }
    });

    var eTimerStop =  $rootScope.$on('timerStop',function () {
        if ($scope.serviceId == configs.payments_config.service.metallist) {
            $state.go('pages.payment',{serviceId:configs.payments_config.service.metallist});
        }else{
            Pay.innerState = 'check';
        }
    });

    $scope.$on('Amount.checkCountAmount', function (meter) {
        Counters.calculateMeters(meter)
    });

    $scope.$on('changeLang', function (event, data) {
        $scope.language = data.lang;
        PortalApi.getService($stateParams.serviceId, $stateParams.url, $scope.language === 'ua' ? 'uk' : $scope.language)
            .then(function(response) {
                Pay.service = response.service;
                Pay.fields = response.fields;
                Pay.commissions = response.commissions;

                Pay.init();
            })
            .catch(function(error) {
                console.error("API Request Failed: ", error);
            });

        DateFormater.takeDate();
    });

    $scope.$on('$destroy', function () {

        ePayInit();
        eSelectProduct();
        eTimerStop();
        eChangeCardNumber();
        eCountAmount();

        $rootScope.$on('changeLang', function () {
            var nowPlace = $location.path();

            if (nowPlace == "/settings") {
                return;
            }

            PortalApi.searchServices({
                // query: $stateParams.serviceId,
                service_id: $stateParams.serviceId,
                furl: $stateParams.url,
                limit: 1,
                id: null,
                sortByPayments: false
            }).then(function (resolve) {

                Pay.data.searchServices = resolve[0]; // search
                $scope.serviceId = Pay.data.getService.service.id;

                Pay.info = Pay.data.searchServices; // element from init
                Pay.service = Pay.data.getService.service;
                Pay.fields = Pay.data.getService.fields;
                Pay.commissions = Pay.data.getService.commissions;

                Pay.init();
            });

            /*if metallist, return to event on lang change*/
            if($scope.serviceId == configs.payments_config.service.metallist){
                $scope.backEvent(3);
            }
            /*end metallist*/
        });
    });

    $scope.getStartBooking = function() {

        Pay.data.booking.loader = true;

        Pay.data.booking.reqData.id = Pay.data.booking.serviceId = Pay.data.serviceId;

        PortalApi.getBookingEvents(Pay.data.booking.reqData).then(function(events) {
            Pay.data.booking.events = events;

        }, function(reason) {
            if(reason.data.text_сode == 'SESSION_ERROR'){
                Localization.notifyTemplate('error', 'ACTIONS.SIGNOUT', 5, true);
                $state.go('pages.booking',{service_id:Pay.data.getService.service.id});
            }
        }).then(function() {
            if (Pay.data.booking.events.length == 1) { //if we have 1 event
                Pay.data.booking.reqData.eventId = Pay.data.booking.events[0].event_id;
                Pay.data.booking.selectedEvent = Pay.data.booking.events[0];
                Pay.data.booking.reservedPlaces = [];

                PortalApi.getEventlayouts(Pay.data.booking.reqData).then(function(res) {
                    Pay.data.booking.layout = res;
                    Pay.data.booking.layout.totalReserveSumm = 0;
                    Pay.data.booking.reqData.layout_id = Pay.data.booking.layout.layout_id;
                    Pay.data.booking.reserveMin = Pay.data.booking.selectedEvent.reserve_time;

                    titleLangChange($scope.language, Pay.data.booking.selectedEvent);

                    //already reserved seats
                    Pay.data.booking.layout.totalReserveSumm = 0;
                    for (var i = 0; i < Pay.data.booking.layout.legends.length; i++) {
                        if (Pay.data.booking.layout.legends[i].reserves.length > 0) {
                            Pay.data.booking.layout.legends[i].numberReservedSeats = Pay.data.booking.layout.legends[i].reserves.length;

                            for (var j = 0; j < Pay.data.booking.layout.legends[i].reserves.length; j++) {
                                var reserve = {
                                    internal_id: Pay.data.booking.layout.legends[i].reserves[j].internal_id,
                                    placeInfo: {}
                                };

                                Pay.data.booking.layout.legends[i].types.forEach( function(type) {
                                    if (type.id == Pay.data.booking.layout.legends[i].reserves[j].type_id) {
                                        if (type.numberReservedSeats) {
                                            type.numberReservedSeats += 1
                                        } else {
                                            type.numberReservedSeats = 1
                                        }
                                    }
                                });
                                reserve.placeInfo = angular.copy(Pay.data.booking.layout.legends[i]);
                                reserve.placeInfo.types.map(function (type) {
                                    if (type.id == Pay.data.booking.layout.legends[i].reserves[j].type_id) {
                                        reserve.placeInfo.type = type;
                                    }
                                });
                                Pay.data.booking.reservedPlaces.push(reserve);
                                Pay.data.booking.layout.totalReserveSumm += reserve.placeInfo.type.price;
                            }
                        }
                    }
                    //

                    if (Pay.data.booking.layout.reserve_ttl) {
                        Pay.data.booking.reserveSec = Math.floor(Pay.data.booking.layout.reserve_ttl);
                    }

                    // change Localization
                    $scope.$on('changeLang', function (event, data) {
                        titleLangChange(data.lang, Pay.data.booking.selectedEvent);
                    });
                    // finish Localization

                    angular.element.get('./static/' + Pay.data.booking.layout.svg + '.svg', {}, function(content) {
                        Pay.data.booking.svgLink = xmlParser(content);
                    }).then(function() {
                        var svgScheme = angular.element('#svgScheme');
                        clearBookingSVG(svgScheme);
                        svgScheme.append(Pay.data.booking.svgLink);
                        svgScheme.find('svg').attr('class', 'staticSVG');

                        for (var i = 0; i < Pay.data.booking.layout.legends.length; i++) {
                            var legend = Pay.data.booking.layout.legends[i];
                            svgScheme.find('svg').find('#'+ legend.unique_id).attr("style", "cursor:pointer").attr({'uib-tooltip': legend.name_uk,'data-tooltip-append-to-body':'true'}).attr("ng-click", "reservePlace(" + legend.legend_id + ")");
                        }
                        // for (var i = 0; i < Pay.data.booking.layout.legends.length; i++) {
                        //     let legend = Pay.data.booking.layout.legends[i];
                        //     $translate('METALLIST.SEATS_AVAILABLE', {seats: legend.places_available}).then(function (text) {
                        //         if (svgScheme.find('svg').find('#'+ legend.legend_id)) {
                        //             svgScheme.find('svg').find('#'+ legend.legend_id).attr({'uib-tooltip': text,'data-tooltip-append-to-body':'true'}).attr("ng-click", "reservePlace(" + legend.legend_id + ")");
                        //         };
                        //     });
                        // };
                       $timeout(function () {
                            $compile(svgScheme.find('svg'))($scope);
                        }, 1000);

                        Pay.data.preLoader = false;
                        Pay.data.booking.loader = false;
                        Pay.data.booking.step = 1;

                    });
                }, function(reason) {
                    if(reason.data.text_сode == 'SERVER_ERROR'){
                        Localization.notifyTemplate('error', 'ACTIONS.SIGNOUT', 5, true);
                        $state.go('pages.booking',{service_id:Pay.data.getService.service.id});
                    }
                });
            };
        });
    };

    $scope.moreTypeInfo = function(type) {
        Pay.data.booking.moreInfoId = type.id;
        if (type.places_available == 0) {
            $timeout(function() {
                Pay.data.booking.moreInfoId = null
            }, 5000);
        }
    };

    function xmlParser(svg) {
        if (window.ActiveXObject) {
            var svgString = svg.xml;
            return svgString;
        }
        else {
            return (new XMLSerializer()).serializeToString(svg);
        }
    }

    function titleLangChange(lang, selectedEvent) {

        if (lang == 'ua') {
            lang = 'uk';
        }

        $scope.changeLangText = {
            name: selectedEvent['name_' + lang],
            address: selectedEvent['address_' + lang]
        };
    }

    function clearBookingSVG(data) {
        if (data.find('svg')) {
            data.find('svg').remove();
        }
    }

    $scope.growImg = function(img) {
        if (img) {
            document.getElementsByTagName('body')[0].style.overflow = "hidden";
            $scope.growImgPopup = {
                show: true,
                url: img
            }
        } else {
            document.getElementsByTagName('body')[0].style.overflow = "auto";
            $scope.growImgPopup = {
                show: false,
                url: ''
            };
        }
    };

    Analytics.pageView();
}

module.exports = PaymentCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/payment/controllers/payment.js
 ** module id = 6
 ** module chunks = 1
 **/